/**
 * WPプラグイン「Bogo」で home_url() のリンクに/thや/enが付くが、お知らせ系は日本語しか存在しないので、
 * お知らせ系のリンクはJSで/thや/enを削除して、代わりに?lang=thのようにパラメータを付ける。

 * langパラメータありでページにアクセスしても、そのページ内のお知らせ系のリンクにもlangパラメータを付ける。

 * こうすることで、langパラメータがある = 他言語ページからのアクセスと判断でき、
 * お知らせ系は日本語ページになるが、一部のテキスト（コード側で定義しているページタイトルなど）のみ他言語に変更することができる（パラメータで言語判定）。
 */

export default class LangOnlyJapanese {
  constructor() {
    this.arrayElemsLinkOnlyLangJa = [...document.querySelectorAll('[data-lang-only-ja]')];
    this.arrayElmsCommonLink = [...document.querySelectorAll('#js-header a, #js-footer a, #js-breadcrumb a')];
    this.arrayLangNavParent = [...document.querySelectorAll('#bogo-modal, #js-sp-lang-btn')];
    this.isNewsPage = document.querySelector('#js-is-news-page') ? true : false; // News系のページかどうか
    this.isNewsSinglePage = document.querySelector('#js-is-news-page-single') ? true : false; // News系の投稿詳細ページかどうか
    this.isNewsSearchPage = document.querySelector('#js-is-news-page-search') ? true : false; // News系の投稿詳細ページかどうか
    this.langParamaKey = 'now_lang';
  }

  /**
   * 今のページの言語取得
   * urlが/言語で始まる or ?lang=言語 なら、その言語を返す
   */
  getNowLang() {
    let url = new URL(window.location.href);
    let pathname = url.pathname;
    let searchParams = new URLSearchParams(url.search);
    // /th または /en を見つけたら、クエリパラメータに置換
    if (pathname.includes('/th')) {
      return 'th';
    } else if (pathname.includes('/en')) {
      return 'en';
    } else if (searchParams.has(this.langParamaKey)) {
      return searchParams.get(this.langParamaKey);
    } else {
      return 'ja';
    }
  }

  /**
   * お知らせ系ページは日本語扱いだから、WPプラグイン「Bogo」の言語切替ナビが日本語になっているから、今の言語に切り替える
   * （お知らせ系のページのみ）
   * @param {String} nowLang 今のページの言語
   */
  setNowLangForToogleLangNav(nowLang) {
    if (!this.isNewsPage) return; // お知らせページ以外は処理しない
    // パラメータsの値を取得
    const url = new URL(window.location.href);
    const searchParam = new URLSearchParams(url.search).get('s') || false;
    // 日本語なら
    if (nowLang === 'ja') {
      // 言語切替ナビのリンクなどを制御
      const arrayElmsNavLink = [...document.querySelectorAll('.bogo-language-switcher a')];
      arrayElmsNavLink.forEach(_link => {
        // 日本語なら何もしない
        if (_link.title === 'Japanese') return;
        const nowLanghrefParam = _link.title === 'English' ? 'en' : _link.hreflang;
        // 他言語なら、?lang=th または ?lang=en を付与
        _link.href = window.location.pathname + `?${this.langParamaKey}=${nowLanghrefParam}`;
      });
      // 日本語の投稿詳細ページか検索結果ページなら
      if (this.isNewsSinglePage || this.isNewsSearchPage) {
        const arrayElmsNavNotJaSpan = [...document.querySelectorAll('.bogo-language-switcher > li:not(.ja) span')];
        // 投稿詳細ページの場合、リンクが付与されないから強制的にリンクを付与
        arrayElmsNavNotJaSpan.forEach(_span => {
          if (_span.textContent === 'Thai') {
            if (searchParam) {
              _span.innerHTML = `<a href="${location.pathname}?s=${searchParam}&${this.langParamaKey}=th">Thai</a>`;
            } else {
              _span.innerHTML = `<a href="${location.pathname}?${this.langParamaKey}=th">Thai</a>`;
            }
          } else if (_span.textContent === 'English') {
            if (searchParam) {
              _span.innerHTML = `<a href="${location.pathname}?s=${searchParam}&${this.langParamaKey}=en">English</a>`;
            } else {
              _span.innerHTML = `<a href="${location.pathname}?${this.langParamaKey}=en">English</a>`;
            }
          }
        });
        // 日本語以外の言語が1つのみの場合、スタイルを調整
        if (arrayElmsNavNotJaSpan.length === 2) { // PCとSPでひとつずつあるから、言語が1つの時はlengthは2になる
          arrayElmsNavNotJaSpan.forEach(_span => {
            _span.parentElement.classList.add('first');
          });
        }
      }
      return;
    }
    // 日本語以外なら
    // ナビを今の言語に切り替える（classを付け替えて見た目を変える）
    const nowLangClass = nowLang === 'en' ? 'en-US' : 'th';
    const arrayElmsNavLink = [...document.querySelectorAll('.bogo-language-switcher a')];
    this.arrayLangNavParent.forEach(_langNav => {
      const elmNav = {
        ja: {
          parent: _langNav.querySelector('.ja.current'),
          link: _langNav.querySelector('.ja.current a'),
        },
        nowLang: {
          parent: _langNav.querySelector(`.bogo-language-switcher > li.${nowLangClass}`),
          link: _langNav.querySelector(`.bogo-language-switcher > li.${nowLangClass} a`),
        },
      };

      //現在の表示がタイ語の時
      if(nowLang == 'th'){
        elmNav.ja.parent.classList.remove('current');
        elmNav.nowLang.parent.classList.add('current');
        elmNav.ja.parent.classList.add('last');
        elmNav.nowLang.parent.classList.remove('last');
      }
      //現在の表示が英語の時
      else if(nowLang == 'en') {
        elmNav.ja.parent.classList.remove('current');
        elmNav.nowLang.parent.classList.add('current');
        elmNav.ja.parent.classList.add('first');
        elmNav.nowLang.parent.classList.remove('last');
      }

      // 投稿詳細ページか検索結果ページなら
      if (this.isNewsSinglePage || this.isNewsSearchPage) {
        const arrayElmsNavNotJaSpan = [...document.querySelectorAll('.bogo-language-switcher > li:not(.ja) span')];
        // 投稿詳細ページの場合、リンクが付与されないから強制的にリンクを付与
        arrayElmsNavNotJaSpan.forEach(_span => {
          if (_span.textContent === 'Thai') {
            if (searchParam) {
              _span.innerHTML = `<a href="${location.pathname}?s=${searchParam}&${this.langParamaKey}=th">Thai</a>`;
            } else {
              _span.innerHTML = `<a href="${location.pathname}?${this.langParamaKey}=th">Thai</a>`;
            }
          } else if (_span.textContent === 'English') {
            if (searchParam) {
              _span.innerHTML = `<a href="${location.pathname}?s=${searchParam}&${this.langParamaKey}=en">English</a>`;
            } else {
              _span.innerHTML = `<a href="${location.pathname}?${this.langParamaKey}=en">English</a>`;
            }
          }
        });
        // 日本語以外の言語が1つのみの場合、スタイルを調整
        if (arrayElmsNavNotJaSpan.length === 2) { // PCとSPでひとつずつあるから、言語が1つの時はlengthは2になる
          arrayElmsNavNotJaSpan.forEach(_span => {
            _span.parentElement.classList.add('first');
          });
        }
      }
      return;
    });
    // ナビの各言語のhrefを書き換える
    arrayElmsNavLink.forEach(_link => {
      // パラメータsの値を取得
      const url = new URL(window.location.href);
      const searchParam = new URLSearchParams(url.search).get('s');
      // 英語
      if (_link.title === 'English') {
        if (searchParam) {
          _link.href = window.location.pathname + `?s=${searchParam}&${this.langParamaKey}=en`;
        } else {
          _link.href = window.location.pathname + `?${this.langParamaKey}=en`;
        }
        return;
      }
      // タイ語
      else if (_link.title === 'Thai') {
        // 他言語なら、?lang=th または ?lang=en を付与
        if (searchParam) {
          _link.href = window.location.pathname + `?s=${searchParam}&${this.langParamaKey}=th`;
        } else {
          _link.href = window.location.pathname + `?${this.langParamaKey}=th`;
        }
        return;
      }
      // 日本語ならパスをそのままにするだけ
      else {
        if (searchParam) {
          _link.href = window.location.pathname + `?s=${searchParam}`;
        } else {
          _link.href = window.location.pathname;
        }
        return;
      }
    });
  }

  /**
   * 全ページ共通系のリンク（ヘッダー、フッター、パンくず）に、今のページの言語（/th または /en）を付与する
   * （お知らせ系のページのみ）
   * @param {String} nowLang 今のページの言語
   */
  translateCommonLink(nowLang) {
    if (!this.isNewsPage) return;
    if (nowLang === 'ja') return;
    this.arrayElmsCommonLink.forEach(_link => {
      // 言語切替のリンクは除外
      if (_link.getAttribute('hreflang')) return;
      // 外部リンクは除外
      if (_link.hostname !== window.location.hostname) return;
      // _link.hrefの先頭に /th または /en を付与
      _link.href = `/${nowLang}${_link.pathname}`;
    });
  }

  /**
   * お知らせ系のリンクのhref属性を書き換える
   * /th または /en を見つけたら、?lang=th または ?lang=en に置換
   * @param {String} nowLang 今のページの言語
   */
  translateNewsHref(nowLang) {
    this.arrayElemsLinkOnlyLangJa.forEach(_link => {
      // hrefに /th または /en が含まれていたら削除
      const href = _link.getAttribute('href');
      _link.href = href.replace(/\/th|\/en/g, '');
      // 最後に、?lang=th または ?lang=en を付与
      _link.href = _link.href + (nowLang === 'ja' ? '' : `?${this.langParamaKey}=${nowLang}`);
    });
  }

  init() {
    const nowLang = this.getNowLang();
    this.setNowLangForToogleLangNav(nowLang);
    this.translateCommonLink(nowLang);
    this.translateNewsHref(nowLang);
  }
}
